import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import AccountServiceModel      from '@/models/AccountServiceModel';
import { accountApiEndpoint }   from '@/models/AccountServiceModel';
import TimestampAble            from '@widesk-core/models/traits/TimestampAble';
import Blamable                 from '@/models/traits/Blamable';
import AccountSubscriptionModel from '@models/account/AccountSubscriptionModel';
import { downloadUrl }          from '@/helpers/DownloadHelper';
import { getLocale }            from '@widesk-core/locale';

@model.urnResource('invoice')
@doc.path('/invoices/{?id}')
export default class InvoiceModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'accountSubscription': id;
		'accountSubscription.account': id;
		'id': id;
		'invoiceStatus': id;
		'invoiceType': id;
		'number': string;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'number': string;
	};

	@doc.number declare amountExcludingVat: number;
	@doc.number declare amountIncludingVat: number;
	@doc.number declare amountVat: number;
	@doc.string declare currency: string;
	@doc.date declare dueDate: Dayjs;
	@doc.string declare number: string;
	@doc.string declare vatRate: string;
	@doc.string declare taxabilityReason: string;
	@doc.model(AccountSubscriptionModel) declare accountSubscription: AccountSubscriptionModel;

	public get invoiceStatusLabel(): string {
		return this.get('invoiceStatus.label', '');
	}

	public get invoiceStatusReference(): Account_InvoiceStatusReference | undefined {
		return this.get('invoiceStatus.reference');
	}

	public get invoiceTypeLabel(): string {
		return this.get('invoiceType.label', '');
	}

	public get invoiceStatusColor() {
		switch (this.invoiceStatusReference) {
			case 'PAID':
				return 'green';
			case 'PENDING_PAYMENT':
				return 'orange';
			case 'CANCELLED':
				return 'red';
			default:
				return 'default';
		}
	}

	public get pdfUrl(): string {
		if (!this.id) return '';

		return `${accountApiEndpoint}/invoices/${this.id}/preview?locale=${getLocale()}`;
	}

	public get fileName(): string {
		return `${this.number || 'facture'}.pdf`;
	}

	public async download() {
		await downloadUrl(this.pdfUrl, this.fileName);
	}
}
